/// <reference path="dataservicebase.ts" />
/// <reference path="../models/meevo.model.custom.ts" />
///<reference path="../short-cuts/index.d.ts"/>


module Meevo.Components.BaseClasses {

    import IAppAreaTab = Meevo.Model.IAppAreaTab;
    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;

    interface IAnswerItem {
        control_TId: Guid,
        item_TId?: Guid,
        displayValue?: string,
        customDataResourceObject?: Meevo.Model.ICustomDataResource,
        customDataResourceObjectList?: Meevo.Model.ICustomDataResource[],
        answerItems?: Array<IAnswerItem>,
        entity_Id?: Guid | string,
        appAreaEnum?: Meevo.Model.AppAreaEnum
    }

    export interface ICustomControlsModel {
        answers: Array<IAnswerItem>
    }

    /**
     * Represents a sub section within a maintenance form.
     * @returns {}
     */
    export abstract class DataMaintenanceSectionBase<T extends Model.DataMaintenance> implements IDataMaintenanceSection<T> {
        loadingInProgress: boolean;
        model: T;
        preSaveModel: T;
        baseEndpoint: string;
        sectionEndpoint: string;
        handlesOwnCrud: boolean;
        displayNameContentKey: string;
        isLoaded: boolean;
        isPrimarySection: boolean;
        isVisible: boolean;
        noun: Meevo.Model.NounEnum;
        sectionId: number;
        shortCutGroup?: IShortCutGroup;
        readonly auditNounForSave?: Meevo.Model.NounEnum;

        protected template: string;
        protected loadTimeStamp: Date;
        protected parentItemId: Guid;
        mode: Meevo.Model.MaintenanceFormState;
        protected loggingService: Meevo.Components.Logging.ILoggingService;
        protected dataService: Meevo.Components.BaseClasses.IDataService;
        protected appSettings: Components.Common.IAppSettings;
        private _customControls: Array<Meevo.Model.IUserDefinedControl> = [];
        private _customControlsModel: ICustomControlsModel;
        private _tab: IAppAreaTab = null;
        private _tabAllBusinessType: IAppAreaTab = null

        protected backup: T;
        private customControlsBackup: Array<Meevo.Model.IUserDefinedControl>;
        sectionSecurityKey: string;
        public isInteropContext = false;

        public disableCrud?: boolean = null;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected translateService?: angular.translate.ITranslateService
        ) {

            this.sectionId = sectionId;
            this.displayNameContentKey = displayNameContentKey;
            this.template = template;
            this.isPrimarySection = isPrimarySection;
            this.handlesOwnCrud = handlesOwnCrud;
            this.baseEndpoint = baseEndpoint;
            this.sectionEndpoint = sectionEndpoint;
            this.loggingService = loggingService;
            this.dataService = dataService;
            this.isVisible = true;
            this.appSettings = appSettings;

            this.loadingInProgress = false;
            this.isLoaded = false;
            this.mode = Meevo.Model.MaintenanceFormState.Readonly;

            this.noun = noun;
            this.sectionSecurityKey = sectionSecurityKey;
        }


        /**
         * Sets the unique (parent) item id of the instance being edited.
         * (i.e. When editing a Client, if you are on the Client Contacts section, this will refer to the ClientId)
         * @param itemId
         * @returns {}
         */
        setParentItemId(parentItemId: Guid): void {
            this.parentItemId = parentItemId;
            this.isLoaded = false;
        }

        /**
         * GEt the unique (parent) item id of the instance being edited.
         * @returns {Guid}
         */
        getParentItemId(): Guid {
            return this.parentItemId;
        }

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         * @returns {}
         */
        activate(subSectionContentKey?: string): void {
            this.isLoaded = true;

            this.getTabAnswers();
        }

        public isSubSectionSelected(subSectionContentKey? : string) : boolean {
            return true;  // always return true if section does not handle any subSections
        }

        selected(subSectionContentKey?: string): void {
        }

        prevUnselected(): void {
        }

        public sectionModelRetrieved(): void {

        }

        public preSave(): void {

        }

        public postCancel(): void {

        }

        public postAdd(): void {

        }
        public postUpdate(): void {

        }
        public isPropertyChanged(name: string): boolean {
            return this.model[name] !== this.backup[name];
        }

        /**
         * Callback on header content click
         */
        public headerContentAction = ($event: any): void => {

        }

        /**
         * Creates a backup of the currently loaded model
         * @returns {}
         */
        takeBackup(): void {
            this.backup = angular.copy(this.model);

            // backup existing custom controls if exist
            if (this.tabInfo !== null) {
                this.customControlsBackup = angular.copy(this.customControls);
            }
        }


        /**
         * Restores the original model values which were stored at the time of load.
         * @returns {}
         */
        rollbackChanges(): void {
            this.model = angular.copy(this.backup);

            // Restores existing custom controls if exist
            if (this.tabInfo !== null) {
                this.customControls = angular.copy(this.customControlsBackup);
            }

            this.sectionModelRetrieved();
        }


        /**
         * Wrapper which assigns sub-class created model instance to the model.
         * @returns {}
         */
        createInstance(postAdd: (data: any) => any): void {
            this.createSectionModelInstance((data: any) => postAdd(data));
        }

        /**
         * Creates an instance of this section for use during an add.
         * @returns {T}
         */
        protected createSectionModelInstance(postAdd: (data: any) => any): void {
            throw (`In order for 'Add' / (createInstance) to work, a section needs to have
        createSectionModelInstance implemented in a subclass.`);
        }


        /**
         * Wrapper which assignes sub-class created model copy to the model.
         * @returns {}
         */
        createCopy(): void {
            this.takeBackup();
            this.model = this.createSectionModelCopy();
            this.updateHomeLocationforCopy();
            if ((this.identityService) && !this.identityService.inCentralOfficeMode()) {
                this.model.businessTypeId = null;
                this.model.businessTypeDetail = null;
            }

        }

        /**
         * Creates a copy of the selected section's model and reassigns it to the model.
         * @returns {T}
         */
        protected createSectionModelCopy(): T {
            this.model.id = null;
            return this.model;
        }

        /**
         * Creates a copy of the selected section's model and reassigns it to the model.
         * @returns {T}
         */
        protected updateHomeLocationforCopy(): void {
            if (!this.identityService) return null;
            this.model.homeLocationId = this.identityService.current().locationId;
        }


        /**
         * If the section instance manages it's own state, this evaluates whether it is in 'Add' mode.
         * @return {boolean}
         */
        get isAdding(): boolean {
            return this.isSectionAdding();
        }

        isSectionAdding(): boolean {
            return this.handlesOwnCrud && this.mode === Meevo.Model.MaintenanceFormState.Adding;
        }

        /**
         * If the section instance manages it's own state, this evaluates whether it is in 'Edit' mode.
         * @return {boolean}
         */
        get isEditing(): boolean {
            return this.isSectionEditing();
        }

        isSectionEditing(): boolean {
            return this.handlesOwnCrud && this.mode === Meevo.Model.MaintenanceFormState.Editing;
        }

        /**
         * If the section instance manages it's own state, this evaluates whether it is in 'Readonly' mode.
         * @return {boolean}
         */
        get isReadonly(): boolean {
            return this.isSectionReadonly();
        }

        isSectionReadonly(): boolean {
            return this.handlesOwnCrud && this.mode === Meevo.Model.MaintenanceFormState.Readonly;
        }

        canEdit(): boolean {
            return true;
        }

        get originalEntity(): T {
            return this.backup;
        }

        /**
         * set list of custom controls
         * */
        set customControls(controls: Array<Meevo.Model.IUserDefinedControl>) {
            this._customControls = controls;
        }

        /**
         * get list of custom controls
         * */
        get customControls(): Array<Meevo.Model.IUserDefinedControl> {
            return this._customControls;
        }

        /**
         * set custom controls model
         * */
        set customControlsModel(model: ICustomControlsModel) {
            this._customControlsModel = model;
        }

        /**
         * get custom controls model
         * */
        get customControlsModel(): ICustomControlsModel {
            return this._customControlsModel;
        }

        /**
         * set tab info
         * */
        set tabInfo(tab: Meevo.Model.IAppAreaTab) {
            this._tab = tab;
        }

        /**
         * get tab info
         * */
        get tabInfo(): Meevo.Model.IAppAreaTab {
            return this._tab;
        }

        set tabInfoAllBusinessType(tab: Meevo.Model.IAppAreaTab) {
            this._tabAllBusinessType = tab;
        }

        get tabInfoAllBusinessType(): Meevo.Model.IAppAreaTab {
            return this._tabAllBusinessType;
        }

        /**
         * get tab info area enum
         * */
        get tabInfoAreaEnum(): Meevo.Model.AppAreaEnum {
            if (this.tabInfoAllBusinessType) {
                return this.tabInfoAllBusinessType.appAreaEnum;
            }
            return this.tabInfo.appAreaEnum;
        }

        /**
         * Get custom controls with answers
         * */
        public getTabAnswers(): ng.IPromise<any> {
            let promise: ng.IPromise<any>,
                customControls: Array<Meevo.Model.IUserDefinedControl> = [];

            if (this.tabInfoAllBusinessType) {
                promise = this.getControls(this.tabInfoAllBusinessType, customControls);
            }

            if (this.tabInfo) {
                if (promise) {
                    promise = promise.then(() => {
                        return this.getControls(this.tabInfo, customControls);
                    });
                } else {
                    promise = this.getControls(this.tabInfo, customControls);
                }
            }

            if (promise) {
                return promise.then(() => {
                    this.customControls = customControls;
                });
            } else {
                return;
            }
        }

        /**
         * Get custom controls with answers by specific tab
         * @param {Meevo.Model.IAppAreaTab} tabInfo
         * @param {Array<Meevo.Model.IUserDefinedControl>} customControls
         * @returns {ng.IPromise<any>}
         */
        getControls(tabInfo: Meevo.Model.IAppAreaTab, customControls: Array<Meevo.Model.IUserDefinedControl>): ng.IPromise<any> {
            return this.dataService.getListPaged(`${this.appSettings.API_ENDPOINTS.customData}/Tab/${tabInfo.tab_TId}/Answer`, {
                criteria: {
                    tab_TId: tabInfo.tab_TId,
                    entity_Id: this.model ? this.model.id : null,
                    appAreaEnum: tabInfo.appAreaEnum
                }
            }).then((data: any) => {
                customControls.push(...data.controls);
            });
        }

        /**
         * Save custom controls values
         * */
        public saveCustomControls(): void {
            if ((this.tabInfo === null && this.tabInfoAllBusinessType === null) || !this.customControlsModel) {
                return;
            }

            this.loadingInProgress = true;

            this.dataService.add(`${this.appSettings.API_ENDPOINTS.customData}/Answer`, {
                answers: this.customControlsModel.answers
            })
                .then(() => {
                    return this.getTabAnswers();
                })
                .then(() => {
                    return this.dataService.getSectionById(this.baseEndpoint, this.parentItemId, this.sectionEndpoint, this.identityService.current().locationId)
                        .then((data: T) => {
                            this.model.entityVersion = data.entityVersion;
                        });
                })
                .finally(() => {
                    this.loadingInProgress = false;
                });
        }

        onModeChange(newMode: Meevo.Model.MaintenanceFormState, context: DataMaintenanceContextBase): void {

        }

    }

}
